export default "__VITE_ASSET__CskUwVDL__"